/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import Icon from '../assets/images/icons/Vector.svg'
import CustomImage from '../components/CustomImage'
import DashLayout from '../components/version-4/Attendance'
import { diffDateInHrs, formatTime } from '../shared/constants'
import { useAttendance } from '../hooks/Features/useAttendance'
import { FeatureContext } from '../context api/Features/FeatureContext'
import { useDashBoard } from '../hooks/DashBoard/useDashBoard'
import { usePosition } from '../hooks/CompanyConfiguration/usePosition'
import { ConfigurationContext } from '../context api/Configuration/ConfigurationContext'
import { SortIcon, FilterIcon } from '../components/CustomComponents/CustomFilterIcon'
import CustomTableLayout from '../components/CustomComponents/CustomTableLayout'

export default function AllAttendance() {
  const { attendances } = useContext(FeatureContext)
  const { deleteManyAttendance, getAllAttendance, BulkUpload, paginate, loading, pdfCsvData, getPdfCsvData, downloadKeys, downloadLoading } = useAttendance()
  const { loading: dashLoading, getAttendanceDashBoard, attendanceDashBoard } = useDashBoard()
  const [selectedDate, setSelectedDate] = React.useState(new Date().toISOString())
  const [searchQuery, setSearchQuery] = React.useState('')
  const [filterParams, setFilterParams] = useState({
    page: 1,
    rank: '',
    firstName: 1,
  })

  const [GridAttend, setGridAttend] = useState(true)
  const startDate = new Date().setHours(0, 0, 0)
  const [from, setFrom] = React.useState(new Date(startDate).toISOString())
  const [to, setTo] = React.useState(new Date().toISOString())
  const [modalOpen, setModalOpen] = React.useState(false)

  const { getAllPosition } = usePosition()
  const { positions } = useContext(ConfigurationContext)

  const noOfPages = paginate && paginate.totalPage

  const handleChange = (event, value) => {
    setFilterParams({
      ...filterParams,
      page: value,
    })
  }

  useEffect(() => {
    if (GridAttend) getAttendanceDashBoard({ from, to })
    getAllAttendance({
      ...filterParams,
      date: selectedDate.slice(0, 10),
      searchQuery,
    })
  }, [filterParams, selectedDate, searchQuery, from, to])

  useEffect(() => {
    getPdfCsvData(downloadKeys.ATTENDANCE, { date: selectedDate.slice(0, 10) })
  }, [selectedDate])

  useEffect(() => {
    getAllPosition()
  }, [])

  const handleGrid = () => {
    setGridAttend(true)
  }

  const statusFilterOptions = [
    { name: 'Absent', _id: 'ABSENT' },
    { name: 'Present', _id: 'PRESENT' },
    { name: 'Late', _id: 'LATE' },
    { name: 'Leave', _id: 'LEAVE' },
  ]

  const headingOnClick = {
    name: () => {
      setFilterParams({ ...filterParams, firstName: -filterParams.firstName })
    },
    position: () => {
      setModalOpen('position')
    },
    status: () => {
      setModalOpen('Present')
    },
  }
  let tableBody = []

  if (!loading && attendances.length > 0) {
    tableBody = attendances.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.EmployeeId && `${item.EmployeeId.firstName} ${item.EmployeeId.lastName}` },
        { value: item.EmployeeId && item.EmployeeId.position && item.EmployeeId.position.positionName },
        { value: item.Present !== 'PRESENT' ? 'N/A' : formatTime(item.attendanceTime) },
        { value: item.Present !== 'PRESENT' ? 'N/A' : item.checkOutTime ? formatTime(item.checkOutTime) : '---' },
        {
          value: item.Present !== 'PRESENT' ? 'N/A' : diffDateInHrs(item.attendanceTime, item.checkOutTime ? item.checkOutTime : new Date()),
        },
        { type: 'LOCATION', location: item.city ? item.city : 'N/A', currentLocation: item.currentLocation },
        { type: 'IMAGE', image: item.picture },
        { type: 'IMAGE', image: item.checkOutImage },
        // {
        //   value: item.updatedBy ? (
        //     <Box textAlign="center">
        //       <Box display="flex" justifyContent="center" marginBottom="5px">
        //         <CustomImage image={Icon} style={{ cursor: 'pointer', marginRight: '5px' }} />
        //         {item.updatedBy && item.updatedBy.firstName}
        //       </Box>

        //       {`${new Date(item.updatedAt).getDate()}/${new Date(item.updatedAt).getMonth() + 1}/${new Date(
        //         item.updatedAt
        //       ).getFullYear()}`}
        //     </Box>
        //   ) : (
        //     '---'
        //   ),
        // },
        { status: item.Present, type: 'STATUS_ENUM', lateFlag: item.lateFlag },
        { type: 'HISTORY', employeeId: item.EmployeeId._id },
      ]
    })
  }

  const layoutProps = {
    heading: 'Attendance',
    editUrl: `/edit-attendance/`,
    filename: 'attendance',
    BulkUpload: BulkUpload,
    dashboardLayout: <DashLayout loading={dashLoading} attendance={attendanceDashBoard} />,
    GridAttend,
    handleGrid,
    handleTable: () => setGridAttend(false),
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    both: true,
    downloadLoading,
    filterRank: filterParams.rank,
    setFilterRank: (newRank) => setFilterParams({ ...filterParams, rank: newRank, page: 1 }),
    selectedFrom: from,
    setSelectedFrom: GridAttend && setFrom,
    selectedTo: to,
    setSelectedTo: GridAttend && setTo,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    selectedDate: selectedDate,
    setSelectedDate: !GridAttend && setSelectedDate,
    permissionName: 'EMPLOYEE',
  }

  const modalData = {
    fieldValue: '_id',
    fieldName: modalOpen === 'position' ? 'positionName' : 'name',
    data: modalOpen === 'position' ? positions : modalOpen === 'Present' ? statusFilterOptions : false,
  }

  return (
    <CustomTableLayout
      heading
      tableHeadings={[
        'name',
        'position',
        'in time',
        'out time',
        'productive hrs',
        'City',
        'check in',
        'check out',
        // 'last modified by',
        'status',
        'history',
      ]}
      loading={loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: filterParams.page }}
      layoutProps={layoutProps}
      checkbox
      headingOnClick={headingOnClick}
      deleteMany={(val, setSelected) => deleteManyAttendance({ attendanceId: val }, setSelected)}
      setFilterParams={setFilterParams}
      filterParams={filterParams}
      filterIcons={{
        name: <SortIcon onClick={headingOnClick['name']} value={filterParams.firstName} />,
        position: <FilterIcon onClick={headingOnClick['position']} value={filterParams.position} />,
        status: <FilterIcon onClick={headingOnClick['status']} value={filterParams.Present} />,
      }}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      modalData={modalData}
    />
  )
}
